export enum ChangeLogWhat {
  ASSESSMENT_SHEET,
  ISSUE_ANALYSIS_TABLE,
  TABLE_ONE,
  TABLE_TWO,
  TABLE_THREE,
}
